import { render, staticRenderFns } from "./StatementFiltersLoader.vue?vue&type=template&id=d2bf1472&scoped=true"
import script from "./StatementFiltersLoader.vue?vue&type=script&lang=ts"
export * from "./StatementFiltersLoader.vue?vue&type=script&lang=ts"
import style0 from "./StatementFiltersLoader.vue?vue&type=style&index=0&id=d2bf1472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bf1472",
  null
  
)

export default component.exports